import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { InstantMessageChannelNew } from "ui/Scripts/source/models/instantMessage/instantMessageChannelNew";
import { InstantMessageChannelEdit } from "ui/Scripts/source/models/instantMessage/instantMessageChannelEdit";
import { InstantMessageChannelAddUsersSuccess } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddUsersSuccess";
import { InstantMessageChannelItems } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItems";
import { getApiCall, postApiCall } from "./tokenService";
import { UserListItems } from "../user/userListItems";

export const getInstantMessageChannelNew = (companyId: string): Promise<InstantMessageChannelNew> => {
    return getApiCall("api/instantmessagechannel/new?id=" + companyId, InstantMessageChannelNew);
};

export const getInstantMessageChannelEdit = (companyId: string, instantMessageChannelId: string): Promise<InstantMessageChannelEdit> => {
    return getApiCall("api/instantmessagechannel/edit?id=" + instantMessageChannelId + "&companyId=" + companyId, InstantMessageChannelEdit);
};

export const saveInstantMessageChannelEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/instantmessagechannel/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeInstantMessageChannel = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessagechannel/remove?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const exitInstantMessageChannel = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessagechannel/exit?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const instantMessageChannelEditRemoveUsers = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessagechannel/editremoveusers", ApiSuccess, JSON.stringify(obj));
};

export const instantMessageChannelEditAddUsers = (obj: any): Promise<InstantMessageChannelAddUsersSuccess> => {
    return postApiCall("api/instantmessagechannel/editaddusers", InstantMessageChannelAddUsersSuccess, JSON.stringify(obj));
};

export const instantMessageChannelEditSetUserType = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessagechannel/editsetusertype", ApiSuccess, JSON.stringify(obj));
};

export const getInstantMessageChannelItems = (companyId: string): Promise<InstantMessageChannelItems> => {
    return postApiCall("api/instantmessagechannel/list", InstantMessageChannelItems, JSON.stringify({
        companyId
    }));
};

export const instantMessageChannelUserInvitationHandle = (id: string, channelId: string, approve: boolean): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessagechannel/invitation?id=" + id + "&channelId=" + channelId + "&approve=" + approve.toString(), ApiSuccess);
};

// #region UserSelect
export const instantMessageChannelGetSelectUserListItems = (channelCompanyId: string, channelId: string, companyId: string, pageSize: number, page: number, filter: string,
    ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, doNotIgnoreRecordUserConnectedUserCode: string,
    sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/instantmessagechannel/selectuserslist", UserListItems, JSON.stringify({
        channelCompanyId,
        channelId,
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserIds,
        ignoreUserCodes,
        ignoreRecordUserConnected,
        doNotIgnoreRecordUserConnectedUserCode,
        activityState
    }));
};
// #endregion UserSelect